export const PACKAGE_TYPE_IDS = {
  PACKAGE_ONE: 1,
  PACKAGE_TWO: 2,
  PACKAGE_THREE: 3,
  PACKAGE_FOUR: 4,
};
